export const dmitryDubovetzky = {
  name: "Dmitry Dubovetzky",
  image: "/authors/dmitry-dubovetzky.jpg",
};
